import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEOHead from '../ui/SEOHead';
import PageHero from '../ui/PageHero';
import useScrollReveal from '../../hooks/useScrollReveal';
import { DOCTORS_DATA } from '../../data/navigation';
import s from './PageContent.module.css';

export default function DoctorPage() {
  useScrollReveal();
  const params = useParams();
  // supports both /doctors/:doctorSlug and /about/:doctorSlug
  const doctorSlug = params.doctorSlug;
  const doctor = DOCTORS_DATA.find(d => d.slug === doctorSlug);

  if (!doctor) return (
    <section className="section"><div className="container">
      <h2>Doctor not found</h2>
      <Link to="/doctors" className="btn btn-primary" style={{marginTop:'20px'}}>Meet Our Doctors</Link>
    </div></section>
  );

  return (
    <>
      <SEOHead
        title={doctor.seo?.title || doctor.name}
        description={doctor.seo?.description || doctor.bio}
        canonical={`/doctors/${doctor.slug}`}
      />
      <PageHero
        eyebrow="Meet Our Doctor"
        title={`${doctor.name}, <em>${doctor.credentials}</em>`}
        subtitle={doctor.specialty}
        breadcrumbs={[{ label: 'Doctors', path: '/doctors' }, { label: doctor.name }]}
        image={doctor.image}
      />

      <section className="section">
        <div className="container">
          <div className={s.pageLayout}>

            {/* ── Main content ─────────────────────────────── */}
            <div className="reveal">
              {/*
               * EDITABLE CONTENT AREA
               * ─────────────────────
               * Edit the `content` field in DOCTORS_DATA (navigation.js).
               * Supports any HTML: <p> <ul> <img> <h2> <h3> etc.
               */}
              {doctor.content ? (
                <div
                  className={s.richContent}
                  dangerouslySetInnerHTML={{ __html: doctor.content }}
                />
              ) : (
                <div className={s.richContent}>
                  <h2>{doctor.name}, {doctor.credentials}</h2>
                  <p>{doctor.bio}</p>
                </div>
              )}

              <div style={{marginTop:'32px'}}>
                <Link to="/book-appointment" className="btn btn-primary btn-primary-lg">
                  Book with {doctor.name.split(' ')[1]}
                </Link>
              </div>
            </div>

            {/* ── Sidebar — doctor photo + contact ─────────── */}
            <div className={s.sidebar}>
              <div style={{borderRadius:'var(--radius-xl)',overflow:'hidden',boxShadow:'var(--shadow-float)',marginBottom:'20px',height:'400px'}}>
                <img src={doctor.image} alt={doctor.name} style={{width:'100%',height:'100%',objectFit:'cover'}} />
              </div>
              <div className={s.sidebarCard}>
                <div style={{display:'flex',alignItems:'center',gap:'14px',marginBottom:'16px'}}>
                  <div style={{width:'52px',height:'52px',borderRadius:'50%',background:'linear-gradient(135deg,var(--blue-200),var(--teal-200))',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'var(--font-display)',fontSize:'18px',fontWeight:'500',color:'var(--blue-800)',flexShrink:0}}>{doctor.avatar}</div>
                  <div>
                    <div style={{fontFamily:'var(--font-display)',fontSize:'16px',fontWeight:'500',color:'var(--blue-900)'}}>{doctor.name}</div>
                    <div style={{fontSize:'12px',color:'var(--slate-400)'}}>{doctor.role}</div>
                  </div>
                </div>
                <div className={s.callBox}>
                  <p>Schedule with {doctor.name.split(' ')[1]}</p>
                  <a href="tel:2152335811">(215) 233-5811</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
